import React, { useState, useEffect } from 'react'
import NextPagination from "../../../components/Pagination/NextPagination"
import { Card, CardBody, Input, FormGroup } from "reactstrap"
import FilterSelect from './Filters/FilterSelect'
import { limitSetting } from "../../helpers/skuFilter"
import CategoryTable from "./CategoryTable"
import { Col, Row, DatePicker, message, Button, Tooltip } from 'antd'
import { getAllProductType } from "../../../services/api/apiSku"
import CategoryCreate from './CategoryCreate'
import { getCategory } from '../../../services/api/apiBatchShip'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import { deleteCategory } from '../../../services/api/apiBatchShip'
import _ from 'lodash'

const { RangePicker } = DatePicker

const CategoryPage = () => {
    const [loading, setLoading] = useState(false)
    const [categorys, setCategorys] = useState([])
    const [filters, setFilters] = useState({})
    const [filtersCache, setFiltersCache] = useState({})
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(0)
    const [error, setError] = useState('')
    const [skus, setSkus] = useState([])
    const [categoryOptions, setCategoryOtions] = useState([])
    const [openCreate, setOpenCreate] = useState(false)
    const [showBulkAtion, setShowBulkAction] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [listSelected, setListSelected] = useState([])
    const [showModalDelete, setShowModalDelete] = useState(false)

    const _handleChangePage = page => {
        setPage(page)
    }

    const _handleChangeLimit = e => {
        const limit = e.target.value
        setLimit(+limit)
    }

    const _fetchListCategorys = async () => {
        setLoading(true)
        try {
            const { names = [], skus = [], updatedAt = {} } = filters
            const payload = {
                page,
                limit
            }

            if (names.length > 0) payload.names = names
            if (skus.length > 0) payload.skus = skus
            if (Object.keys(updatedAt).length > 0) payload.updatedAt = updatedAt

            const { data: res } = await getCategory(payload)

            const { success, data, message } = res

            if (!success) throw new Error(message)

            const { total, data: listData } = data
            setTotal(total)
            setCategorys(listData)

        } catch (error) {
            setError(error)
        } finally {
            setLoading(false)
        }
    }

    const _fetchListSku = async () => {
        try {
            const payload = {
                is_deleted: false,
            }

            const { data: response } = await getAllProductType(payload)

            const { success, data, message } = response

            if (!success) throw new Error(message)

            const newData = data.map(i => ({ label: i.sku, value: i._id })).sort((a, b) => _.get(a, 'label').localeCompare(_.get(b, 'label')))

            if (newData.length > 0) setSkus(newData)

        } catch (err) {
            message.error(err.message)
        }
    }

    const _fetchOptionCategories = async () => {
        try {
            const payload = {
                page: 1,
                limit: 1000
            }

            const { data: res } = await getCategory(payload)

            const { success, data, message } = res

            if (!success) throw new Error(message)

            const { data: listData } = data
            setCategoryOtions(listData.map(i => ({ label: i.name, value: i.name })))

        } catch (error) {
            setError(error)
        }
    }

    const _handleChangeFilters = (filter = {}) => {
        setFilters(preFilters => ({
            ...preFilters,
            ...filter
        }))
    }

    const handleChangeFilterCache = (filter = {}) => {
        setFiltersCache(preFilters => ({
            ...preFilters,
            ...filter
        }))
    }

    const onChangeDate = (date, dateString) => {
        if (Array.isArray(date)) {
            const [from, to] = date
            if (!!from && !!to) {
                _handleChangeFilters({
                    updatedAt: {
                        from: moment(from).startOf('day').toISOString(),
                        to: moment(to).endOf('day').toISOString(),
                    }
                })
            }
        } else {
            _handleChangeFilters({
                updatedAt: {}
            })
        }
    }

    useEffect(() => {
        _fetchListCategorys()
    }, [page, limit, filters])

    useEffect(() => {
        _fetchListSku()
        _fetchOptionCategories()
    }, [])

    const _toggleOpen = () => {
        setShowBulkAction(!showBulkAtion)
    }

    const handleSelectAll = (isChecked) => {
        setSelectAll(isChecked)
        setListSelected(isChecked ? categorys : [])
    }

    const handleSelectItem = (categoryId, isChecked) => {
        const newList = isChecked ? [...listSelected, ...categorys.filter(i => i._id === categoryId)] : listSelected.filter(i => i._id !== categoryId)
        setSelectAll(newList.length === categorys.length)
        setListSelected(newList)
    }

    const toggleModal = (field) => {
        if (field === 'showModalDelete') {
            setShowModalDelete(!showModalDelete)
            if (showModalDelete) {
                setSelectAll(false)
                setListSelected([])
                _toggleOpen()
            }
        }
    }

    const onDelete = async (item) => {
        const { _id, name } = item || {}
        try {
            const { data } = await deleteCategory(_id)
            const { success, message: mess } = data
            if (!success) {
                throw new Error(mess || 'Delete failed')
            }
            return { _id, name, success: true }
        } catch (e) {
            return { _id, name, success: false, error: e.message }
        }
    }

    const handleMultiDelete = async () => {
        const results = await Promise.allSettled(
            listSelected.map(item => onDelete(item))
        )

        const outcomes = results.map(r =>
            r.status === 'fulfilled' ? r.value : { success: false, error: r.reason.message }
        )
        const failed = outcomes.filter(o => !o.success)
        if (failed.length) {
            // Show lỗi từng item
            outcomes.forEach(o => {
                o.success ? message.success(`Xóa danh mục ${o.name} thành công`) : message.error(`Xóa ${o.name} lỗi: ${o.error}`)
            })
            _fetchListCategorys()
        } else {
            message.success('Xóa danh mục thành công.')
            toggleModal('showModalDelete')
            _toggleOpen()
            _fetchListCategorys()
        }
    }

    const formatName = (name = '') => {
        if (name.length > 30) {
            return <Tooltip title={name} trigger="hover" placement="topLeft" zIndex={9999}>
                <span className='cursor-pointer'>{name.slice(0, 30) + '...'}</span>
            </Tooltip>
        }
        return name
    }

    return (
        <div className="CategoryPage">
            <div className="BackWrapper mb-2">
                <Link to='/sku-manager'><i className='fa fa-chevron-left mr-1' />Quản lý Sku</Link>
            </div>
            <Card>
                <div className="CardHeader card-header header-elements-inline d-flex aligin-items-center pb-2">
                    <h1 className='card-title'>Danh mục sản phẩm</h1>
                    <Button type='primary' onClick={() => setOpenCreate(true)}>Thêm mới</Button>
                    <CategoryCreate
                        isOpen={openCreate}
                        onCancel={() => setOpenCreate(false)}
                        skus={skus}
                        reload={_fetchListCategorys}
                    />
                </div>

                <CardBody>
                    <div className="CategoryFilters pt-3 pl-3 pr-3 mb-3">
                        <Row
                            gutter={{
                                xs: 8,
                                sm: 16,
                                md: 24,
                                lg: 32,
                            }}
                        >
                            <Col className="gutter-row" span={6}>
                                <FilterSelect
                                    field='names'
                                    value={filters['names']}
                                    onChangeFilter={_handleChangeFilters}
                                    onChangeFilterCache={handleChangeFilterCache}
                                    filtersCache={filtersCache}
                                    options={categoryOptions || []}
                                    placeholder="Nhập tên danh mục"
                                    label='Danh mục sản phẩm'
                                    mode="multiple"
                                    type="filter"
                                />
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <FilterSelect
                                    field='skus'
                                    value={filters['skus']}
                                    onChangeFilter={_handleChangeFilters}
                                    onChangeFilterCache={handleChangeFilterCache}
                                    filtersCache={filtersCache}
                                    options={skus}
                                    placeholder="Chọn SKU"
                                    mode="multiple"
                                    label='SKU'
                                    type="filter"
                                />
                            </Col>
                            <Col className="gutter-row" span={6}>
                                <FormGroup className="d-flex flex-column">
                                    <label className='font-weight-bold mb-1'>Ngày cập nhật</label>
                                    <RangePicker
                                        ranges={{
                                            Today: [moment(), moment()],
                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                        }}
                                        onChange={onChangeDate}
                                        placeholder={['Bắt đầu', 'Kết thúc']}
                                        format={'DD/MM/YYYY'}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                    <div className="SkuTotal d-flex justify-content-between align-items-center mb-3">
                        <div className='d-flex align-items-center'>
                            <div className='d-flex align-items-center'>
                                <div className="CustomSelect">
                                    <Button onClick={_toggleOpen}
                                        className="dropdown-toggle" disabled={listSelected.length === 0}>Hành động</Button>
                                    <div className={showBulkAtion ? 'ListAction open' : 'ListAction'}>
                                        <div className='ChangeStatusProduct'>
                                            <Button color='link' onClick={() => toggleModal('showModalDelete')}>Xóa danh mục sản phẩm</Button>
                                            <Modal isOpen={showModalDelete} toggle={() => toggleModal('showModalDelete')}>
                                                <ModalHeader toggle={() => toggleModal('showModalDelete')}>Xóa danh mục sản phẩm</ModalHeader>
                                                <ModalBody>
                                                    <div>
                                                        Bạn có chắc chắn muốn xóa <strong>{listSelected.length}</strong> danh mục sản phẩm
                                                    </div>
                                                    <div className="listItem d-flex flex-wrap mt-2 font-weight-bold" style={{ maxHeight: '245px', overflowY: 'auto' }}>
                                                        <ul style={{ width: '230px' }}>
                                                            {listSelected.map((i, idx) => (
                                                                idx < Math.ceil(listSelected.length / 2) &&
                                                                <li key={i._id} className='mb-1'>{formatName(i.name)}</li>
                                                            ))}
                                                        </ul>
                                                        <ul style={{ width: '230px' }}>
                                                            {listSelected.map((i, idx) => (
                                                                idx >= Math.ceil(listSelected.length / 2) &&
                                                                <li key={i._id} className='mb-1'>{formatName(i.name)}</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                    {error && <span className='text-danger mt-3'>{error}</span>}
                                                </ModalBody>
                                                <ModalFooter className='d-flex justify-content-between align-items-center'>
                                                    <Button disabled={loading} type="secondary" onClick={() => toggleModal('showModalDelete')}>Hủy</Button>
                                                    <Button disabled={loading} type="primary" onClick={handleMultiDelete}>{loading &&
                                                        <i className='fa fa-spin fa-spinner mr-2' />}Xóa</Button>
                                                </ModalFooter>
                                            </Modal>
                                        </div>
                                    </div>
                                    {
                                        showBulkAtion && <div className="Background" onClick={_toggleOpen} />
                                    }
                                </div>
                                <div className='ml-2'>
                                    Đã chọn <strong>
                                        {listSelected.length}</strong> sản phẩm

                                </div>
                            </div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='d-flex align-items-center mr-3'>
                                <div>Hiển thị</div>
                                <Input type='select' value={limit} name='limit' onChange={_handleChangeLimit}
                                    className='ml-1 mr-1 w-auto'>
                                    {
                                        limitSetting.map(item => {
                                            return <option key={item.value} value={item.value}>{item.name}</option>
                                        })
                                    }
                                </Input>
                            </div>
                            <div>
                                Tổng số <strong>{total}</strong> danh mục sản phẩm
                            </div>
                        </div>
                    </div>
                    <CategoryTable
                        categorys={categorys}
                        loading={loading}
                        error={error}
                        reload={_fetchListCategorys}
                        skus={skus}
                        listSelected={listSelected}
                        selectAll={selectAll}
                        handleSelectAll={handleSelectAll}
                        handleSelectItem={handleSelectItem}
                    />
                    <div className="mt-3 float-right">
                        <NextPagination
                            limit={limit}
                            total={total}
                            page={page}
                            onChange={_handleChangePage}
                        />
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}

export default CategoryPage